// hooks
import { Fragment, useEffect, useState, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import useHttp from "hooks/use-http";

import { MdDelete, MdEdit } from "react-icons/md";

// material styles
import {
  Grid,
  IconButton,
  Tooltip,
  TextField,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";

// material icons
import { FilterAlt, Delete, Download } from "@mui/icons-material";

import { RiNumbersFill } from "react-icons/ri";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import DatePickerCM from "components/shared/DatePicker";
import TableCM from "components/shared/Table";
import PaginationCM from "components/shared/Pagination";
import DeleteModal from "components/shared/Modal/Delete";

// helper
import GenerateHeadCell from "helper/generate-head-cell";
import spliter from "helper/digit-spliter";
import Toast from "helper/toast";

// styled component
import {
  StyledStack,
  StyledDateBox,
  StyledMenuItem,
  StyledGridIcons,
} from "./showExcellScores.style";

// request methods
import { getTeacherScoresExcellFileByIdRequest } from "api/requests";

// constants
import { PAGINATION_LIMIT } from "constants";

import { useNavigate, useParams } from "react-router-dom";
import { convertNum } from "helper/convert-num";
import BackButton from "components/shared/BackButton";

// excell scores head cells
const headCells = GenerateHeadCell("excellScores_view_list");
export default function ShowExcellScores() {
  const { scores_excell_file_id } = useParams();
  const {
    register,
    control,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const { request, loading, setLoading } = useHttp(false);

  // excellScores data state
  const [excellScoresData, setExcellScoresData] = useState({
    data: [],
    count: 0,
  });

  // page state for pagination
  const [page, setPage] = useState(1);

  const getScoresExcellFileData = useCallback(async () => {
    const res = await request({
      url: getTeacherScoresExcellFileByIdRequest,
      values: { id: scores_excell_file_id },
    });
    if (res) {
      if (res.data.studentScores.length < 1) {
        return setExcellScoresData({
          data: [{ content: "اطلاعات یافت نشد" }],
          count: 0,
        });
      }

      let transformedData = res?.data?.studentScores
        ?.filter((item) => item?.is_present == true)
        .map((item) => ({
          id: item.id,
          full_name: `${item?.student.first_name} ${item?.student.last_name}`,
          score: item?.score ?? "غایب",
          raw_score: item?.raw_score ?? "غایب",
          rank: item?.rank ?? "غایب",
          correct: item?.correct ?? "غایب",
          not_ans: item?.not_ans ?? "غایب",
          wrong: item?.wrong ?? "غایب",
        }));

      setExcellScoresData({
        data: transformedData,
        count: transformedData.length,
      });
    }
  }, []);
  useEffect(() => {
    getScoresExcellFileData();
  }, [page]);

  return (
    <DrawerCM title="مشاهده نمرات " $styledHeader>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route="/teacher_scores_excell-file" />
            </Grid>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست نمرات "
                rows={excellScoresData.data}
                headCells={headCells}
                page={page}
                colspan={excellScoresData.count === 0 ? "8" : ""}
                fontSize="14px"
                cellFontSize="14px"
              />
            </Grid>
            {excellScoresData.data.length < 1 ? (
              ""
            ) : (
              <Grid
                item
                xs={12}
                my={2}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <PaginationCM
                  handleChange={(_, val) => setPage(val)}
                  page={page}
                  count={excellScoresData.count}
                />
              </Grid>
            )}
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
